const helperText = 'Invite a new user and assign them permissions.';
export default helperText;
